'use strict'
// ac0d7f0f-ef9c-48b6-8d8a-6b7a75b0a036  keybox
exports = module.exports = {
  // List of user roles
  userRoles: ['guest', 'user', 'admin'],
  encryptKey: '8chLv9pat4WlE5IzyUwF9lOEtRYaPo9d1v0EYQnIak8iJDHLdIkJQW994iQZzLIoMhErq190IU8NEYACVnkrxtr6uOXTqkWuiClOC5ACbIWB0zUk5hALBaGWEvXDhudK',
  newEncryptKey: 'f6135e24571e312e31563926519d1676',
  ThirdPartyToken: ['a870d5fd-66db-4d2d-9dd7-d4a0e4ebe45b', '648220d9-7b90-43fd-bc2d-d217e00da1a7', 'ff210891-9cf5-4555-bede-4c6965459da7', 'ac0d7f0f-ef9c-48b6-8d8a-6b7a75b0a036', 'f225c15b-c50e-4f76-83b6-19bba5485a66', '4c6c3119-b8bb-4d97-909a-5f5c6b77e92a']
}



//////////////////
// WEBPACK FOOTER
// ./server/config/environment/shared.js
// module id = 104
// module chunks = 0